import { useTranslation } from "react-i18next";
import type { DraftAutosaveStatus } from "../pages/messaging/hooks";
import { cn, Spinner } from "@tellescope/design-system";
import { Check } from "lucide-react";

export interface DraftAutosaveIndicatorProps {
  status: DraftAutosaveStatus;
}

export const DraftAutosaveIndicator = ({ status }: DraftAutosaveIndicatorProps) => {
  const { t } = useTranslation("inbox");

  if (status === "idle") {
    return null;
  }

  return (
    <span
      className={cn(
        "flex gap-2 items-center self-center text-xs text-muted-foreground",
        status === "saved" && "text-green-700"
      )}
      aria-live="polite"
    >
      {status === "saving" ? <Spinner size="xxs" /> : <Check size={12} />}
      {status === "saving" ? t("Saving draft...") : t("Draft saved")}
    </span>
  );
};
